import {useNavigate, useParams} from "react-router-dom"
import {useUpdateUserPassword} from "hooks/query/user-query"
import {useForm} from "react-hook-form"
import {NotificationType, showNotification} from "common/Notification"
import {FormErrorBox} from "common/FormErrorBox"
import {useEffect} from "react"

type formValue = {
    id: string,
    password: string,
    passwordConfirm: string
}

export function UpdateUserPassword() {
    const {register, handleSubmit, formState: {errors}, setError, watch, setValue} = useForm<formValue>()
    const navigate = useNavigate()
    const {id} = useParams()
    const mutate = useUpdateUserPassword()

    const submit = (value: formValue) => {
        if (!id) {
            showNotification("선택된 사용자가 없습니다")
            return
        }
        if (value.password !== value.passwordConfirm) {
            setError("passwordConfirm", {
                message: "비밀번호가 서로 같지 않습니다"
            })
        }
        mutate.mutate({id, password: value.password}, {
            onSuccess: () => {
                showNotification("비밀번호를 변경했습니다", NotificationType.SUCCESS)
                setValue("passwordConfirm", "")
                setValue("password", "")
            },
            onError: () => showNotification("비밀번호를 변경하지 못했습니다")
        })
    }

    return (
        <form onSubmit={handleSubmit(submit)}>
            <div className="mt20 ml20">
                <div className="gray-label is-size-85">password</div>
                <div className="">
                    <input className="input is-gray" type="password" placeholder="비밀번호"
                           {...register("password", {
                               required: "비밀번호가 필요합니다", minLength: {
                                   value: 4,
                                   message: "4글자 이상이어야 합니다"
                               }
                           })}
                    />
                    <FormErrorBox error={errors.password}/>
                </div>
            </div>
            <div className="mt20 ml20">
                <div className="gray-label is-size-85">password 확인</div>
                <div className="">
                    <input className="input is-gray" type="password" placeholder="비밀번호 확인"
                           {...register("passwordConfirm", {required: "비밀번호 확인이 필요합니다"})}
                    />
                    <FormErrorBox error={errors.passwordConfirm}/>
                </div>
            </div>
            <div className="hr-line-dashed ml20 mt30"></div>

            <div className="mt30 ml20">
                <button className="button is-purple2">변경</button>
                <div className="button is-clickable ml-2" onClick={() => navigate("/user/list")}>취소</div>

            </div>
        </form>
    )
}